import {
  AlertType,
  ISubscriptionItem,
  ISubscriptionItemBase,
  ISubscriptionItemClassificationChange,
  ISubscriptionItemSampleAvailable,
  ISubscriptionItemYaraMatch,
  SubscriptionHashes
} from "../@types";
import { ALERT_TYPES_MAP, DEFAULT_EVENT_TYPE_OPTIONS } from "../const";

type UseAlertSubscriptionDefaultsProps = {
  type?: AlertType;
  shouldUseHashes?: boolean;
  subscriptionHashes?: SubscriptionHashes;
  shouldUseYaraSubscription?: boolean;
  yaraSubscriptions?: Array<string>;
};

const useAlertSubscriptionDefaults = ({
  type,
  shouldUseHashes = false,
  subscriptionHashes = [],
  shouldUseYaraSubscription = false,
  yaraSubscriptions
}: UseAlertSubscriptionDefaultsProps) => {
  const sampleAvailableHashes = shouldUseHashes
    ? subscriptionHashes
        ?.filter(item => !item.available)
        ?.map(item => item.sha1)
    : [];

  const baseHashValues = shouldUseHashes
    ? subscriptionHashes?.map(item => item.sha1)
    : [];

  const createSubscription = (
    subscriptionType: AlertType
  ): ISubscriptionItem | undefined => {
    switch (subscriptionType) {
      case ALERT_TYPES_MAP.SAMPLE_AVAILABLE:
        return {
          id: null,
          type: ALERT_TYPES_MAP.SAMPLE_AVAILABLE,
          type_options: DEFAULT_EVENT_TYPE_OPTIONS.sample_available,
          hash_specific: true,
          hash_values: shouldUseHashes ? sampleAvailableHashes : []
        } as ISubscriptionItemSampleAvailable;
      case ALERT_TYPES_MAP.CLASSIFICATION_CHANGE:
        return {
          id: null,
          type: ALERT_TYPES_MAP.CLASSIFICATION_CHANGE,
          type_options: DEFAULT_EVENT_TYPE_OPTIONS.classification_change,
          hash_specific: shouldUseHashes || false,
          hash_values: shouldUseHashes ? baseHashValues : []
        } as ISubscriptionItemClassificationChange;
      case ALERT_TYPES_MAP.YARA_MATCH:
        return {
          id: null,
          type: ALERT_TYPES_MAP.YARA_MATCH,
          type_options: shouldUseYaraSubscription
            ? { rulesets: shouldUseYaraSubscription ? yaraSubscriptions : [] }
            : DEFAULT_EVENT_TYPE_OPTIONS.yara_match,
          hash_specific: false,
          hash_values: []
        } as ISubscriptionItemYaraMatch;

      default:
        return {
          id: null,
          type: subscriptionType,
          type_options:
            DEFAULT_EVENT_TYPE_OPTIONS[
              subscriptionType as keyof typeof DEFAULT_EVENT_TYPE_OPTIONS
            ] || {},
          hash_specific: false,
          hash_values: []
        } as ISubscriptionItemBase;
    }
  };

  const defaultSubscriptions = type
    ? createSubscription(type)
    : Object.values(ALERT_TYPES_MAP).map(subscriptionType =>
        createSubscription(subscriptionType)
      );

  return { defaultSubscriptions: defaultSubscriptions as ISubscriptionItem[] };
};

export default useAlertSubscriptionDefaults;
